import { num } from '../utils';

// Close rate over sales visits only: a service visit is not a lost sale.
export interface Outcome { n: number; sales: number; won: number; lost: number; }
export const rate = (o: Outcome): number | null => (o.sales ? o.won / o.sales : null);

// Same reading as the CFO dashboard: colour carries the verdict, the number carries the detail.
export type Band = 'good' | 'ok' | 'warn' | 'bad' | 'none';
export function band(value: number | null): Band {
  if (value === null) return 'none';
  if (value >= 0.5) return 'good';
  if (value >= 0.3) return 'ok';
  if (value >= 0.15) return 'warn';
  return 'bad';
}

export const pctText = (v: number | null): string => (v === null ? '—' : `${Math.round(v * 100)}%`);

interface RateCellProps {
  o: Outcome;
  active: boolean;
  onClick: () => void;
  // Optional wording for screens whose numerator is not a close (e.g. secondhand introductions).
  title?: string;
}

export function RateCell({ o, active, onClick, title }: RateCellProps) {
  if (!o.n) return <span className="muted">—</span>;
  const r = rate(o);
  return (
    <button type="button" className={`ins-cell b-${band(r)} ${active ? 'is-selected' : ''}`} aria-pressed={active} onClick={onClick}
      title={title || `${num(o.won)} chốt / ${num(o.sales)} lượt mua · ${num(o.lost)} mất dấu · ${num(o.n)} lượt`}>
      <b className="tnum">{pctText(r)}</b>
      <span className="ins-cell-bar"><i style={{ width: `${Math.round((r || 0) * 100)}%` }} /></span>
      <small className="tnum">{num(o.won)}/{num(o.sales)}</small>
    </button>
  );
}
